import { EyeIcon } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import {Link} from 'react-router-dom';
import BlogSkeleton from "../components/BlogSkeleton";
import featuredPost from '../components/featuredPost';
import ReadingTime from '../components/ReadingTime';
import { Helmet } from "react-helmet"

<Helmet>
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "Blog",
        "name": "Radar Pulsa Artikel",
        "url": "https://radarpulsa.com/artikel"
      }
    `}
  </script>

</Helmet>

export default function Artikel() {
  const [visibleSections, setVisibleSections] = useState(new Set());
  const [posts,setPosts] = useState([])
  const [page,setPage] = useState(1)
  const [totalPage,setTotalPage] = useState(1)
  const [loading,setLoading] = useState(true)
  const [featured,setFeatured] = useState(null)

  const [category,setCategory] = useState("all")
  const [search,setSearch] = useState("")
  

  const loadPosts = async()=>{

    const res = await fetch(
      process.env.REACT_APP_BASE_URL + `api/events?page=${page}&category=${category}&search=${search}`
    )

    const data = await res.json()
      setPosts(data.data)
      setTotalPage(data.total_page)
      setFeatured(data.data[0])
      setLoading(false)
    }

  useEffect(()=>{
   loadPosts()
  },[page,category,search])

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[data-section]');
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.75 && rect.bottom > 0;
        
        if (isVisible) {
          setVisibleSections(prev => new Set([...prev, section.getAttribute('data-section')]));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
  };

  const fetchSectionHero = async () => {
      
    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/sectionhero/artikel`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setSectionHero(json.data[0] || []);

    } catch (err) {
        console.error("Fetch Pc error:", err);
    }
  };
  
  useEffect(() => {
    fetchSectionHero();
  }, []);  

  const [sectionHero, setSectionHero] = useState({
    title: "",
    page: "",
    description: "",
    image: "", 
  });
  
  const [contactData, setContactData] = useState(true);
  
  const fetchContactData = async () => {
    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/contactdata/1`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setContactData(json.data || []);

    } catch (err) {
        console.error("Fetch Running error:", err);
    }
  };
  
  useEffect(() => {
    fetchContactData();
  }, []); 

  return (
    <div className="min-h-screen bg-slate-950 text-white pt-20">
      {/* Header Section */}
      <section
        data-section="header"
        className="
          relative
          h-[32vh] md:h-[40vh] lg:h-[45vh]
          overflow-hidden
          flex items-center justify-center
          bg-slate-950
        "
      >
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src={`${process.env.REACT_APP_BASE_URL}uploads/images/${sectionHero.image}`}
            alt="background"
            className="w-full h-full object-cover"
          />
          
          {/* Overlay depth */}
          <div className="absolute inset-0 bg-slate-950/60"></div>

          {/* Gradient Glow */}
          <div className="absolute inset-0 bg-gradient-to-b from-slate-900/30 via-slate-950/50 to-slate-950"></div>

          {/* Optional Glow Accent */}
          <div className="absolute top-1/4 left-1/3 w-72 h-72 bg-blue-500/20 blur-[120px] rounded-full"></div>
          <div className="absolute bottom-1/4 right-1/3 w-72 h-72 bg-red-500/20 blur-[120px] rounded-full"></div>
        </div>

        {/* Content */}
        <div
          className={`
            relative z-10
            px-6
            text-center
            max-w-5xl
            mx-auto
            translate-y-[2vh]
            transition-all duration-1000
            ${
              visibleSections.has("header")
                ? "opacity-100"
                : "opacity-0 translate-y-[5vh]"
            }
          `}
        >
          <h1
            className="
              font-bricolage
              font-bold
              tracking-tight
              leading-tight
              mb-4
              bg-gradient-to-r
              from-blue-400 via-white to-red-400
              bg-clip-text text-transparent
              text-[clamp(2rem,6vw,4.5rem)]
            "
          >
            {sectionHero.page}
          </h1>

          <div className="w-16 md:w-24 h-1 rounded-full bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-5"></div>

          <p
            className="
            mx-auto
            max-w-xs sm:max-w-2xl
            text-gray-300
            leading-relaxed
            text-[clamp(.95rem,1.8vw,1.15rem)]
            "
          >
            {sectionHero.description}
          </p>
        </div>
      </section>

      {/* Projects Grid */}
      <section 
        data-section="projects"
        className="py-16 bg-slate-950"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-300 ${
          visibleSections.has('projects') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="flex flex-row py-8 gap-4 justify-between">
            <input
              type="text"
              placeholder="Cari artikel, event, berita..."
              className="border text-black p-3 rounded-xl w-full md:w-1/2"
              onChange={(e)=>setSearch(e.target.value)}
            />
            <select
              className="border p-3 rounded-xl text-black w-full md:w-1/4"
              onChange={(e)=>setCategory(e.target.value)}
            >
              <option value="all">All Category</option>
              <option value="1">Article</option>
              <option value="2">Blog</option>
              <option value="3">News</option>
              <option value="4">Event</option>
            </select>
          </div>
          {loading ? (
            <BlogSkeleton/>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map(post => (
                <>
                  <div
                    className="group relative overflow-hidden rounded-2xl bg-slate-800/50 border border-slate-700 hover:border-blue-500/50 transition-all duration-500 transform hover:scale-105"
                    style={{ 
                      transitionDelay: `${1 * 100}ms`,
                      animation: 'fadeIn 0.5s ease-out'
                    }}
                  >
                    <div className={`aspect-video bg-gradient-to-br from-blue-600 to-red-600 relative overflow-hidden`}>
                      <div className="absolute inset-0 flex items-center justify-center">
                        <img src={`${process.env.REACT_APP_BASE_URL}uploads/images/${post.image}`} alt="" className="w-full" />
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                      
                      {/* Hover Overlay */}
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <Link to={`/post/${post.slug}`}>
                          <button className="px-6 py-3 bg-white text-slate-900 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-300">
                            Baca selengkapnya...
                          </button>
                        </Link>
                      </div>
                    </div>
                    
                    <div className="p-6">
                      <h3 className="text-xl font-bold mb-2 text-white group-hover:text-blue-400 transition-colors duration-300">
                        {post.title}
                      </h3>
                      <p className="text-gray-400 text-sm mb-4">
                        <div
                          className="line-clamp-3 text-white"
                          dangerouslySetInnerHTML={{ __html: post.description }}
                        />...
                      </p>
                      <div className="flex justify-between text-sm text-gray-500">
                        <div className="flex flex-wrap gap-2">
                          {post.hashtag}
                        </div>
                        {/* <span className="flex items-center flex-row gap-1">
                          <EyeIcon size={14}></EyeIcon> {post.views ?? 0} 
                        </span> */}
                        <span>
                          {formatDate(post.created_at)}
                        </span>
                      </div>  
                    </div>
                  </div>
                </>
              ))}
            </div>
          )}
          <div className="flex gap-2 mt-8 justify-center">
            {[...Array(totalPage)].map((_,i)=>(
              <button
                key={i}
                onClick={()=>setPage(i+1)}
                className={`px-4 py-2 border ${
                page===i+1 ? "bg-gradient-to-r from-blue-600 to-red-600 rounded-full font-semibold hover:shadow-lg hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300":"bg-slate-700 text-gray-300 rounded-full"
                }`}
              >
                {i+1}
              </button>
            ))}

          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section 
        data-section="stats"
        className="py-24 bg-gradient-to-b from-slate-950 to-slate-900"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-400 ${
          visibleSections.has('stats') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="text-center mb-4">
            <h2 className="font-bricolage text-2xl sm:text-3xl md:text-5xl font-bold mb-4 md:mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent leading-tight">
              Akun Official Radar Pulsa
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-blue-500 mx-auto"></div>
            <p className="text-sm sm:text-base md:text-xl text-gray-400 mb-6 md:mb-8 max-w-xl mx-auto leading-relaxed">
              Ikuti perkembangan event ter update nya hanya di akun social media official Radar Pulsa.
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8 px-4 sm:px-6">
            {[
              { number: 'Radar Pulsa Official', label: 'Facebook', icon: "/images/facebook.png", link:contactData.facebook },
              { number: '@radarpulsa_official', label: 'Instagram', icon: "/images/instagram.png", link:contactData.instagram },
              { number: 'radarpulsa.official', label: 'Tiktok', icon: "/images/tiktok.png", link:contactData.tiktok },
              { number: 'youtube.com/radarpulsa', label: 'Youtube', icon: "/images/youtube.png", link:contactData.youtube },
            ].map((stat, index) => (
              <Link to={stat.link} target="_blank">
                <div
                  key={index}
                  className="text-center p-8 bg-slate-800/50 backdrop-blur-sm rounded-2xl border border-slate-700 hover:border-blue-500/50 transition-all duration-300 transform hover:scale-105"
                  style={{ transitionDelay: `${index * 100}ms` }}
                >
                  <div className="flex justify-center text-5xl mb-4">
                    <img
                      src={stat.icon}
                      className="h-36"
                    />
                  </div>
                  <div className={`text-3xl font-bold mb-2 bg-gradient-to-r ${
                    index % 2 === 0 ? 'from-blue-400 to-cyan-400' : 'from-red-400 to-pink-400'
                  } bg-clip-text text-transparent`}>
                    {stat.label}
                  </div>
                  <div className="text-gray-400">{stat.number}</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section 
        data-section="cta"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
        </div>

        <div
          className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 delay-400 ${
            visibleSections.has('cta')
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-10'
          }`}
        >
          {/* TITLE */}
          <h2 className="font-bricolage text-2xl sm:text-3xl md:text-5xl font-bold mb-4 md:mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent leading-tight">
            Ayo bergabung menjadi mitra Kami!
          </h2>

          {/* DESC */}
          <p className="text-sm sm:text-base md:text-xl text-gray-400 mb-6 md:mb-8 max-w-xl mx-auto leading-relaxed">
            Kami tidak hanya menyediakan layanan, tetapi membangun kemitraan jangka panjang untuk perkembangan bisnis Anda.
          </p>

          {/* BUTTON */}
          <div className="flex justify-center">
            <Link
              to="https://play.google.com/store/apps/details?id=com.otoreport.radarpulsa&hl=id"
              target="_blank"
              className="
                w-full sm:w-auto
                px-6 sm:px-8 md:px-10
                py-3 sm:py-4
                bg-gradient-to-r from-blue-600 to-red-600
                rounded-full
                font-semibold
                text-sm sm:text-base md:text-lg
                text-center
                hover:shadow-xl md:hover:shadow-2xl
                hover:shadow-blue-500/40
                transform md:hover:scale-105
                transition-all duration-300
              "
            >
              Mulai mendaftar
            </Link>
          </div>
        </div>
      </section>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
